import {useMemo} from "react";

import Select from "components/Select";

import {LinkedPatient} from "liberty-core/api/models";

import styles from "./TitlePatientNameSelect.module.css";

const DEFAULT_PATIENT_ID = "defaultPatientId";

type Props = {
  className?: string;
  defaultPatientName: string;
  linkedPatients: LinkedPatient[];
  selectedPatientId: string | null;
  onChange: (selectedPatientId: string | null) => void;
};

export default function TitlePatientNameSelect(props: Props) {
  const options = useMemo(
    () =>
      [
        {
          value: DEFAULT_PATIENT_ID,
          label: props.defaultPatientName,
        },
        ...props.linkedPatients.map((p) => ({
          value: p.patientId,
          label: `${p.firstName} ${p.lastName}`,
        })),
      ].sort((a, b) => {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      }),
    [props.defaultPatientName, props.linkedPatients],
  );

  return (
    <Select
      className={props.className}
      selectClassName={styles.select}
      options={options}
      onChange={(v) => {
        if (v === DEFAULT_PATIENT_ID) {
          props.onChange(null);
        } else {
          props.onChange(v);
        }
      }}
      value={props.selectedPatientId ?? DEFAULT_PATIENT_ID}
    />
  );
}
